<template>
  <div class="m-portlet">
    <div class="m-portlet__head">
      <div class="m-portlet__head-caption">
        <div class="m-portlet__head-title">
          <h3 class="m-portlet__head-text">
            Task template manager
          </h3>
        </div>
      </div>
    </div>
    <div class="m-portlet__body">
      <div class="flex align-items-center">
        <table class="table">
          <tr>
            <td>Temlplate name</td>
            <td>Tasks</td>
            <td></td>
          </tr>
          <tr v-for="template in templates" v-if="!template.deleted">
            <td>
              <div class="flex">
                <div class="flex align-items-center mr-3 pointer" @click="removeTemplate(template)">
                  <i class="fas fa-times"></i>
                </div>
                <input type="text" v-model="template.name" class="form-control" placeholder="Template name">
              </div>
            </td>
            <td>
              <div v-for="(task, index) in template.template" class="flex mb-3">
                <input type="text" v-model="task.name" class="form-control mr-1" placeholder="Task name">
                <input type="text" v-model="task.duration" class="form-control ml-1 mr-1" placeholder="1:00">
                <div @click="removeTask(template, task)">
                  <svg-trash-can></svg-trash-can>
                </div>
              </div>
              <div class="btn btn-outline-success w-100" @click="addTask(template)">Add task</div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="btn btn-outline-success w-100" @click="addTemplate()">Add new template</div>
            </td>
          </tr>
        </table>
      </div>

      <div>
        <button class="btn btn-success" @click="save" :disabled="saving">Save</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.load()
  },
  data() {
    return {
      templates: [],
      saving: false,
    }
  },
  methods: {
    load() {
      return this.axios.get('/n/task-templates').then(response => {
        this.templates = response.data.data
      })
    },
    removeTask(template, task) {
      template.template = _.reject(template.template, t => t.name === task.name)
    },
    removeTemplate(template) {
      if (template.can_be_removed) {
        this.templates = _.reject(this.templates, t => t.id === template.id)
      } else {
        this.$set(template, 'deleted', true)
      }
    },
    save() {
      this.saving = true
      this.axios.put('/n/update-task-templates', {templates: this.templates}).then(() => {
        this.$awn.success('Saved.')
        this.load().finally(() => this.saving = false)
      }).catch(() => {
        this.saving = false
      })
    },
    addTemplate() {
      this.templates.push({
        can_be_removed: true,
        id: 'new-' + _.uniq(),
        name: null,
        template: [
          {name: null, duration: "1:00"}
        ]
      })
    },
    addTask(template) {
      template.template.push({
        name: null,
        duration: "1:00"
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/config/task-template-manager.vue